var heading_default = {
  "fontElementMap": "_4kCwI",
  "elementSpacing": "S1YGA",
  "headerOne": "fLcdq S1YGA",
  "headerTwo": "lcaeU S1YGA",
  "headerThree": "Gd3m5 S1YGA",
  "headerFour": "FUmxW S1YGA",
  "headerFive": "_4oZ00 S1YGA",
  "headerSix": "poxM- S1YGA",
  "child": "tJhS2"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
